export const dynamicPriceIntervalTime = 180000;
